module.exports = __webpack_public_path__ + "f6a9b5cd5d6672b43281ecb58bc20a94.jpg";